module.exports = {
	extends: [
		'/',
		'base',
		'tableSimple',
		'table',
	],

	config: {
		supportLazyloading: false,
	},

	methods: {},
}